export enum GutterOption {
    None,
    OneSide,
    TwoSides
};
